import { render, staticRenderFns } from "./BodyModule.vue?vue&type=template&id=6beaf06c&scoped=true"
import script from "./BodyModule.vue?vue&type=script&lang=js"
export * from "./BodyModule.vue?vue&type=script&lang=js"
import style0 from "./BodyModule.vue?vue&type=style&index=0&id=6beaf06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6beaf06c",
  null
  
)

export default component.exports